// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes lMpio{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}@keyframes u9GhV{0%{width:0}100%{width:16ch}}@keyframes grnAj{0%{opacity:0;transform:translateY(0) scale(0.98)}100%{opacity:1;transform:translateY(0) scale(1)}}.oJNMB{border:1px solid #d4d4e0;border-radius:8px;flex:1;min-height:0;display:flex;flex-direction:column;overflow:hidden}.YL71Q{padding:0;flex:1;min-height:0;display:flex;flex-direction:column}.jbntv{padding:16px;overflow:auto;flex:1;min-height:0;-webkit-overflow-scrolling:touch}.VsqOf{animation:grnAj 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;animation-delay:.1s;opacity:0;word-wrap:break-word;overflow-wrap:break-word;width:100%}.exYQx{display:inline-block;background:linear-gradient(135deg, #2CF1FF 0%, #9578FF 50%, #FF36E7 100%);background-size:200% 100%;background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;color:transparent;animation:u9GhV .85s steps(13, end) forwards,lMpio 3s ease-in-out infinite;overflow:hidden;white-space:nowrap;width:0}.E6UXX{border-bottom-left-radius:8px;border-bottom-right-radius:8px;padding:12px;flex-shrink:0;border-top:1px solid transparent;box-shadow:0 -4px 12px 0 rgba(40,40,99,0);transition:border-top-color .3s ease,box-shadow .3s ease}.swGhc{border-top-color:#d4d4e0;box-shadow:0 -4px 12px 0 rgba(40,40,99,.12)}.uq5c8{background:#8768f9;color:#fff}.uq5c8:hover{background:#8768f9 !important;color:#fff !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `oJNMB`,
	"content": `YL71Q`,
	"contentWrapper": `jbntv`,
	"descriptionContent": `VsqOf`,
	"fadeInFromTop": `grnAj`,
	"textWithDots": `exYQx`,
	"typing": `u9GhV`,
	"gentleGradient": `lMpio`,
	"actionRow": `E6UXX`,
	"actionRowWithScroll": `swGhc`,
	"insertedButton": `uq5c8`
};
export default ___CSS_LOADER_EXPORT___;
